export { default as Img200 } from './processed/200/Line-Of-Duty-S5.jpg';
export { default as Img400 } from './processed/400/Line-Of-Duty-S5.jpg';
export { default as Imgthumb } from './processed/thumb/Line-Of-Duty-S5.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Line-Of-Duty-S5.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Line-Of-Duty-S5.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      133,
      49,
      50
    ],
    "_population": 176,
    "_hsl": [
      0.998015873015873,
      0.4615384615384616,
      0.3568627450980392
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      25,
      40
    ],
    "_population": 1508,
    "_hsl": [
      0.5694444444444444,
      0.8181818181818182,
      0.08627450980392157
    ]
  },
  "Muted": {
    "_rgb": [
      144,
      101,
      89
    ],
    "_population": 52,
    "_hsl": [
      0.03636363636363636,
      0.23605150214592277,
      0.4568627450980392
    ]
  },
  "LightMuted": {
    "_rgb": [
      205,
      163,
      155
    ],
    "_population": 152,
    "_hsl": [
      0.026666666666666655,
      0.3333333333333335,
      0.7058823529411764
    ]
  },
  "DarkMuted": {
    "_rgb": [
      90,
      40,
      39
    ],
    "_population": 500,
    "_hsl": [
      0.0032679738562091387,
      0.39534883720930236,
      0.2529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Line-Of-Duty-S5.js